import { ENTRYPOINT } from '../../../config/entrypoint';
import { API_ROUTES } from '../../../constants/api_routes';
import { CONTENT_TYPE, TOKEN_TYPE } from '../../../constants/constants';
import { REACT_ROUTES } from '../../../constants/react_routes';
import { deleteData, getData, getHeaders, postData, putData } from '../../../http/request';
import history from '../../../services/history';

export const PLACE_ACTION_TYPES = {
	GET_PLACES_SUCCESS: 'GET_PLACES_SUCCESS',
    POST_PLACE_SUCCESS: 'POST_PLACE_SUCCESS',
    PUT_PLACE_SUCCESS: 'PUT_PLACE_SUCCESS',
    DELETE_WORKER_SUCCESS: 'DELETE_CUSTOMER_SUCCESS',
    UPDATE_PLACES_PAGINATION: 'UPDATE_PLACES_PAGINATION'
};

const PLACES_URL = `${ENTRYPOINT}${API_ROUTES.PLACES}`;

const getPaginationParams = ({ page, rowsPerPage }) => {
    return `?page=${page+1}&itemsPerPage=${rowsPerPage}&pagination=true`;
}

const getFilterParams = (params, filters = {}) => {
    const { search } = filters;
    let filterParams = params;
    if (search) {
        filterParams = `${filterParams}&search=${search}`;
    }
    return filterParams;
}

export const getPlaces = (data = { page: 0, rowsPerPage: 10, filters: { } }) => {
    return async (dispatch) => {
        let params = getPaginationParams(data);
        const { filters } = data;
        params = getFilterParams(params, filters);
        const GET_PLACES_URL = `${PLACES_URL}${params}`;
        const response = await getData(GET_PLACES_URL, getHeaders(TOKEN_TYPE.TOKEN, CONTENT_TYPE.LD_JSON));
        dispatch({ type: PLACE_ACTION_TYPES.GET_PLACES_SUCCESS, payload: response['hydra:member'] });
        dispatch({ type: PLACE_ACTION_TYPES.UPDATE_PLACES_PAGINATION, payload: { totalCount: response['hydra:totalItems'] } });
    }
}

export const getPlace = async (uuid) => {
    const GET_PLACE_URL = `${PLACES_URL}/${uuid}`;
    return await getData(GET_PLACE_URL, getHeaders());
}

export const postPlace = (data) => {
    return async (dispatch) => {
        const response = await postData(PLACES_URL, data);
        dispatch({ type: PLACE_ACTION_TYPES.POST_PLACE_SUCCESS, payload: response });
        return history.push(REACT_ROUTES.PLACES);
    }
}

export const putPlace = (uuid, data) => {
    return async (dispatch) => {
        const PUT_WORKERS_URL = `${PLACES_URL}/${uuid}`;
        const response = await putData(PUT_WORKERS_URL, data);
        dispatch({ type: PLACE_ACTION_TYPES.PUT_PLACE_SUCCESS, payload: response });
        history.push(REACT_ROUTES.PLACES);
    }
}

export const deletePlace = (uuid) => (
    async () => {
        const DELETE_PLACE_URL = `${PLACES_URL}/${uuid}`;
        await deleteData(DELETE_PLACE_URL);
        // dispatch({ type: CUSTOMERS_ACTION_TYPES.DELETE_CUSTOMER_SUCCESS, payload: uuid });
    }
)

export const updatePlacesPagination = ({ rowsPerPage, page = 0, filters }) => {
    return (dispatch) => {
        dispatch({ type: PLACE_ACTION_TYPES.UPDATE_PLACES_PAGINATION, payload: { rowsPerPage, page, filters } });
        dispatch(getPlaces({ page, rowsPerPage, filters }));
    }
}

